module.exports = __webpack_public_path__ + "img/momo_button_home.cf7f8473.png";